import { render, staticRenderFns } from "./ConsentEdit.vue?vue&type=template&id=c6b38912&"
import script from "./ConsentEdit.vue?vue&type=script&lang=js&"
export * from "./ConsentEdit.vue?vue&type=script&lang=js&"
import style0 from "./ConsentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports